import { Icon } from "@circle-react/components/shared/Icon";
import { useHelpWidgetContext } from "../../context/HelpWidgetContext";

const HeaderSidebarButton = () => {
  const { isSidebarOpen, collapseSideBar, expandSideBar } =
    useHelpWidgetContext();

  const handleClick = () => {
    if (isSidebarOpen) {
      collapseSideBar();
    } else {
      expandSideBar();
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="hover:bg-tertiary w-8 rounded-lg p-1"
    >
      <Icon type="sw-expand-sidebar" useWithFillCurrentColor size={16} />
    </button>
  );
};

export default HeaderSidebarButton;
